import * as React from 'react';
import { TabsContainer } from './Tabs.js';
import { Tab } from './Tab.js';
import './NavTabs.scss.js';

const NavTabs = React.forwardRef(function NavTabs2(props, ref) {
  return /* @__PURE__ */ React.createElement(TabsContainer, {
    ...props,
    htmlIdName: "nav tabs",
    containerType: "vai-nav-tabs",
    orientation: "horizontal",
    ref
  });
});
NavTabs.Tab = Tab;

export { NavTabs };
